import { Suspense } from 'react';
import { Routes as RouterRoutes, Route } from 'react-router';

import { RouteScreen } from './RouteScreenRevamp';
import { useBeforeUnload } from 'hooks/useBeforeUnload';
import { RedirectComponent } from './RedirectComponent';
import { PageNotFound } from './PageNotFound';
import { useRoutes, UseRoutesReturnRevamp } from './useRoutes';
import { usePartner } from 'components/app/routes/usePartner';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { NsxHeader } from 'components/common/nsx-header/NsxHeader';
import { usePreload } from 'components/app/routes/usePreload';

export const Routes = () => {
  const {
    routes,
    shouldShowPrompt,
    shouldRedirect
  } = useRoutes<UseRoutesReturnRevamp>();
  const { partnerPath } = usePartner();

  useBeforeUnload(shouldShowPrompt);
  usePreload(routes);

  return (
    <>
      <NsxHeader />

      <RouterRoutes>
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              shouldRedirect ? (
                <RedirectComponent path={partnerPath} />
              ) : (
                <Suspense fallback={<NsStopgap />}>
                  <RouteScreen route={route} routes={routes} />
                </Suspense>
              )
            }
          />
        ))}
        <Route path="*" element={<PageNotFound />} />
      </RouterRoutes>
      <nsx-footer />
    </>
  );
};
